import Vue from 'vue'
import VueRouter from 'vue-router'
import zh from '@/views/zh.vue';
import en from '@/views/en.vue';
import ja from '@/views/ja.vue';
import ko from '@/views/ko.vue';
import pt from '@/views/pt.vue';
import es from '@/views/es.vue';
import de from '@/views/de.vue';
import ru from '@/views/ru.vue';
import fr from '@/views/fr.vue';
import it from '@/views/it.vue';

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/enUserprotocol',
		component: en,
		meta: {
			title: 'Ix Cam Cloud Storage User Agreement'
		}
	},
	{
		path: '/enUserprotocol',
		name: 'enUserprotocol',
		component: en,
		meta: {
			title: 'Ix Cam Cloud Storage User Agreement'
		}
	},
	{
		path: '/userProtocol',
		name: 'userProtocol',
		component: zh,
		meta: {
			title: 'Ix Cam云存储用户协议'
		}
	},
	{
		path: '/jaUserprotocol',
		name: 'jaUserprotocol',
		component: ja,
		meta: {
			title: 'Ix Camクラウドストレージ利用規約'
		}
	},
	{
		path: '/esUserprotocol',
		name: 'esUserprotocol',
		component: es,
		meta: {
			title: 'Acuerdo de usuario de almacenamiento en la nube de ix Cam'
		}
	},
	{
		path: '/ptUserprotocol',
		name: 'ptUserprotocol',
		component: pt,
		meta: {
			title: 'Contrato de Utilizador do ix Cam Cloud Storage'
		}
	},
	{
		path: '/ruUserprotocol',
		name: 'ruUserprotocol',
		component: ru,
		meta: {
			title: 'Пользовательское соглашение ix Cam Cloud Storage'
		}
	},
	{
		path: '/deUserprotocol',
		name: 'deUserprotocol',
		component: de,
		meta: {
			title: 'Ix Cam Cloud Storage-Benutzervereinbarung'
		}
	},
	{
		path: '/koUserprotocol',
		name: 'koUserprotocol',
		component: ko,
		meta: {
			title: 'Ix Cam 클라우드 스토리지 사용자 계약'
		}
	},
	{
		path: '/frUserprotocol',
		name: 'frUserprotocol',
		component: fr,
		meta: {
			title: "Contrat d'utilisation du stockage infonuagique Ix Cam"
		}
	},
	{
		path: '/itUserprotocol',
		name: 'itUserprotocol',
		component: it,
		meta: {
			title: "Contratto d'uso per l'archiviazione cloud Ix Cam"
		}
	}
]

const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	console.log(to.meta.title)
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	next();
})
export default router
